import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { router } from "../../Constants";
import Gap from "../../components/Gap";
import LoadingFull from "../../components/LoadingFull";
import api from "../../request";
import { decrypt, encrypt } from "../../utils/enkripsi";
import formatterMoney from "../../utils/formatMoney";
import { showLog } from "../../utils/log";
import { onHitung } from "../../utils/onHitung";
import { socket } from "../../utils/socket";
import "./paymentsucces.scss";

function PaymentSuccess({ }) {
  let navigate = useNavigate();
  const [data, setData] = React.useState({});
  const orderDate = JSON.parse(localStorage.getItem("dataBranch"));
  const { addToast } = useToasts();
  const caraBayar = localStorage.getItem("typePayment") || "";

  useEffect(() => {
    showLog("PaymentSuccess Masuk useEffect 1");

    const handlePopstate = () => {
      navigate(router + "/bill");
    };

    const run = async () => {
      localStorage.setItem("saveCustomer", JSON.stringify(encrypt("false")));
      const result = await api.apiPrepare.getOrder({
        id: orderDate.detailData,
      });
      const x = onHitung(result.data);
      let data = {};
      data["tanggal"] = result.data[0]["trans_date"];
      data["total"] = x.data["grand_total_net"];
      setData(data);

      await onCallSocketIO();
      const tableQrPayloadEmail = decrypt(
        JSON.parse(sessionStorage.getItem("tableQrPayloadEmail"))
      );
      // let sendEmailReturn = await send_email(tableQrPayloadEmail);
      // if (sendEmailReturn.status == "OK") {
      //   addToast("Invoice sudah terkirim ke email anda", {
      //     appearance: "success",
      //     autoDismiss: true,
      //   });
      // } else {
      //   addToast("Invoice gagal terkirim ke email anda", {
      //     appearance: "error",
      //     autoDismiss: true,
      //   });
      // }
    };

    run();
    window.addEventListener("popstate", handlePopstate);
    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, [navigate, orderDate?.detailData]);

  async function onCallSocketIO() {
    showLog("PaymentSuccess Masuk onCallSocketIO");
    const tableQrSocketData = decrypt(
      JSON.parse(sessionStorage.getItem("tableQrSocketData"))
    );
    const savedSiSocketData = decrypt(
      JSON.parse(sessionStorage.getItem("savedSiSocketData"))
    );
    if (socket?.connected) {
      showLog(`Socket Connected With ID = ${socket.id}`);
    } else {
      socket.once("connect", () =>
        showLog(`Socket Connected With ID = ${socket.id}`)
      );
    }
    tableQrSocketData.detailData.delivery_receiver_name =
      localStorage.getItem("dataDiriName") || "";
    tableQrSocketData.posData.detailData.delivery_receiver_name =
      localStorage.getItem("dataDiriName") || "";
    socket.emit("table-qr-print", tableQrSocketData);
    socket.emit("saved-si", savedSiSocketData);
    socket.emit("call-kitchen", {
      branch_id: JSON.parse(localStorage.getItem("dataBranch")).branchID,
      userServer: JSON.parse(localStorage.getItem("userServer")),
    });
  }

  return (
    <div>
      {data.total ? (
        <div className="sea">
          <div className="circle-wrapper">
            <div className="bubble"></div>
            <div className="submarine-wrapper">
              <div className="submarine-body">
                <div className="checkmark"></div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <span className="fonts700" style={{ fontSize: 23 }}>
              Payment Success
            </span>
            <Gap height={10} />
            <span className="fonts500" style={{ fontSize: 19 }}>
              {data.tanggal}
            </span>
            <Gap height={50} />
            <span className="fonts700" style={{ fontSize: 25 }}>
              Rp{formatterMoney(data.total)}
            </span>
          </div>
          <Gap height={30} />
          <div
            style={{ borderBottom: "1px solid #8c8c8c", margin: "0 50px" }}
          />
          <Gap height={30} />
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <span className="fonts700" style={{ fontSize: 15 }}>
              Makanan yang sudah dibayar tidak bisa dicancel
            </span>
            <Gap height={20} />
            <span className="fonts700" style={{ fontSize: 23 }}>
              Thank You
            </span>
          </div>
          <Gap height={50} />
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              onClick={() => {
                localStorage.setItem(
                  "fromPaymentSuccess",
                  JSON.stringify(encrypt("true"))
                );
                if (caraBayar == "Cash") {
                  navigate(router + "/bill-cash");
                } else {
                  navigate(router + "/bill");
                }
              }}
              className="button_bill"
            >
              <span style={{ color: "#552CB7" }} className="fonts700">
                Lihat Bill
              </span>
            </div>
            <div></div>
          </div>
        </div>
      ) : (
        <LoadingFull />
      )}
    </div>
  );
}

export default PaymentSuccess;
